import React, { useState } from 'react';
import { Box, makeStyles, Paper, useMediaQuery } from '@material-ui/core';
import { Layout } from '@roc/feature-app-core';
import { StandardDialog, Tabs } from '@roc/ui';
import InspectionsDashboardGrid from './components/dashboard/inspectionsDashboardGrid';
import useInspectionStore from './hooks/useInspectionStore';
import { InspectionsDashboardTabs } from './types/types';
import { observer } from "mobx-react";
import { InspectionReport } from './inspectionReport';
import { useTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { UsersMediaGallery } from './gallery';

const TABS = [{
  value: InspectionsDashboardTabs.INSPECTIONS_DRAWS,
  label: 'Draws',
},
{
  value: InspectionsDashboardTabs.INSPECTIONS_INTERNAL_VALUATIONS,
  label: 'Internal Valuation',
},
{
  value: InspectionsDashboardTabs.MEDIA_LIBRARY,
  label: 'Media Library',
}
];


const useStyles = makeStyles(() => ({
  container: {
    maxWidth: '1400px',
  },
  paper: {
    boxShadow: 'none !important',
    border: '1px solid #cdcdcd',
    padding: '0px',
    borderRadius: '0 !important',
  },
  dialog: {
    '& .MuiDialogContent-root': {
      padding: 0,
      '& > .MuiBox-root': {
        margin: 0,
      },
    },
  },
  smallScreen: {
    '& .MuiDialog-paper': {
      margin: '4px',
    },
    '& .MuiDialog-paperFullWidth': {
      width: 'calc(100% - 8px)'
    },
    '& .MuiDialog-paperScrollPaper': {
      maxHeight: 'calc(100% - 8px)'
    },
  }
}));

export const InspectionsDashboard = observer(({ }) => {
  const classes = useStyles();
  const { inspectionStore } = useInspectionStore();
  const { tab } = inspectionStore;
  const theme = useTheme();
  const bigHeight = useMediaQuery('(min-height:900px)');
  const bigWidth = useMediaQuery(theme.breakpoints.down('xl'));
  const smallScreen  =!bigHeight || !bigWidth;

  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [inspectionId, setInspectionId] = useState();

  const handleOpenReportModal = (inspectionId) => {
    setIsReportModalOpen(true);
    setInspectionId(inspectionId);
  };

  const handleCloseReportModal = () => {
    setIsReportModalOpen(false);
    setInspectionId(null);
  };

  const isInternalValuationInspection = tab === InspectionsDashboardTabs.INSPECTIONS_INTERNAL_VALUATIONS;
  const isMediaLibrary = tab === InspectionsDashboardTabs.MEDIA_LIBRARY;

  return (
    <>
      <Layout
        title={'Inspections Dashboard'}
        containerClass={classes.container}>
        <Box>
          <Tabs
            selectedTab={TABS.findIndex(({ value }) => value === tab)}
            tabs={TABS}
            onTabChange={(e, i) => inspectionStore.setTab(TABS[i].value)}
          />
        </Box>
        <Box>
          <Paper className={classes.paper}>
            {isMediaLibrary ? (
              <UsersMediaGallery />
            ) : (
              <InspectionsDashboardGrid store={inspectionStore} onOpenInspection={handleOpenReportModal} isInternalValuationInspection={isInternalValuationInspection} />
            )}
          </Paper>
        </Box>
      </Layout>
      <StandardDialog
        className={clsx(classes.dialog,  smallScreen && classes.smallScreen)}
        open={isReportModalOpen}
        handleClose={handleCloseReportModal}
        maxWidth='xl'
        removeContentBox
        dialogContent={
          inspectionId && <InspectionReport smallScreen={smallScreen} inspectionId={inspectionId} isInternalValuationPropertyPhotosContactFlow={isInternalValuationInspection} />
        }
      />
    </>
  );
});
